var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaMensal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0026 46C92.0026 71.1275 71.5684 91.5 46.3581 91.5C21.1479 91.5 0.713623 71.1275 0.713623 46C0.713623 20.8725 21.1479 0.5 46.3581 0.5C71.5684 0.5 92.0026 20.8725 92.0026 46Z",
    stroke: "#737791"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9802_103906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7061 54.9164V63H61.0691V54.9164H65.7061ZM54.1136 54.9164V63H49.452V54.9164H54.1136ZM42.4965 54.9164V63H37.9336V54.9164H42.4965ZM30.9288 54.9164V63H26.4151V54.9164H30.9288Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7061 24V46.6339H61.0691V24H65.7061ZM54.1136 41.5599V46.6339H49.452V41.5599H54.1136ZM42.4965 30.8648V46.6339H37.9336V30.8648H42.4965ZM30.9288 39.6945V46.6339H26.4151V39.6945H30.9288Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9733 52.7525C25.0631 52.7525 25.9465 51.8617 25.9465 50.7627C25.9465 49.6638 25.0631 48.7729 23.9733 48.7729C22.8835 48.7729 22.0001 49.6638 22.0001 50.7627C22.0001 51.8617 22.8835 52.7525 23.9733 52.7525Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9915 52.7525C31.0813 52.7525 31.9647 51.8617 31.9647 50.7627C31.9647 49.6638 31.0813 48.7729 29.9915 48.7729C28.9017 48.7729 28.0183 49.6638 28.0183 50.7627C28.0183 51.8617 28.9017 52.7525 29.9915 52.7525Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9851 52.7525C37.0748 52.7525 37.9582 51.8617 37.9582 50.7627C37.9582 49.6638 37.0748 48.7729 35.9851 48.7729C34.8953 48.7729 34.0119 49.6638 34.0119 50.7627C34.0119 51.8617 34.8953 52.7525 35.9851 52.7525Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0032 52.7525C43.093 52.7525 43.9764 51.8617 43.9764 50.7627C43.9764 49.6638 43.093 48.7729 42.0032 48.7729C40.9135 48.7729 40.0301 49.6638 40.0301 50.7627C40.0301 51.8617 40.9135 52.7525 42.0032 52.7525Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9968 52.7525C49.0866 52.7525 49.97 51.8617 49.97 50.7627C49.97 49.6638 49.0866 48.7729 47.9968 48.7729C46.907 48.7729 46.0236 49.6638 46.0236 50.7627C46.0236 51.8617 46.907 52.7525 47.9968 52.7525Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.015 52.7525C55.1047 52.7525 55.9882 51.8617 55.9882 50.7627C55.9882 49.6638 55.1047 48.7729 54.015 48.7729C52.9252 48.7729 52.0418 49.6638 52.0418 50.7627C52.0418 51.8617 52.9252 52.7525 54.015 52.7525Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0332 52.7525C61.123 52.7525 62.0064 51.8617 62.0064 50.7627C62.0064 49.6638 61.123 48.7729 60.0332 48.7729C58.9435 48.7729 58.06 49.6638 58.06 50.7627C58.06 51.8617 58.9435 52.7525 60.0332 52.7525Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0267 52.7525C67.1165 52.7525 67.9999 51.8617 67.9999 50.7627C67.9999 49.6638 67.1165 48.7729 66.0267 48.7729C64.937 48.7729 64.0536 49.6638 64.0536 50.7627C64.0536 51.8617 64.937 52.7525 66.0267 52.7525Z",
    fill: "#737791"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9802_103906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 39,
    fill: "white",
    transform: "translate(22 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaMensal);
export default __webpack_public_path__ + "static/media/media-mensal.d48e493d6d705a8a087eace7f4b96e2c.svg";
export { ForwardRef as ReactComponent };